var __jsx = React.createElement;
import React from "react";
import stl from "./TimeSlot.module.css";
var SingleTimeSlote = function SingleTimeSlote(_ref) {
  var text = _ref.text,
    disabled = _ref.disabled,
    active = _ref.active,
    updateTime = _ref.updateTime,
    updateSeletedDayAndTime = _ref.updateSeletedDayAndTime;
  return /*#__PURE__*/React.createElement("div", {
    className: [stl.singleTimeSloteContainer, active ? stl.activeSlot : undefined].join(" "),
    disabled: disabled,
    onClick: function onClick() {
      updateTime ? updateTime() : undefined;
      updateSeletedDayAndTime ? updateSeletedDayAndTime() : undefined;
    }
  }, text);
};
export default SingleTimeSlote;